import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgTutorialsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.278.304a.75.75 0 00-.556 0l-10 4a.75.75 0 000 1.392L4.25 7.108V12c0 1.223.954 2.183 2.172 2.792 1.253.626 2.9.958 4.578.958 1.678 0 3.325-.332 4.578-.958 1.218-.61 2.172-1.569 2.172-2.792V7.108l2.5-1V11a.75.75 0 001.5 0V5a.75.75 0 00-.471-.696l-10-4zM5.75 7.217v-.034a.748.748 0 011.029-.68L11 8.194l4.222-1.69a.75.75 0 011.028.68v.034a.75.75 0 01-.472.68l-4.5 1.8a.75.75 0 01-.556 0l-4.5-1.8a.75.75 0 01-.472-.68z",
    fill: "currentColor"
  })));
}

export { SvgTutorialsSolid as ReactComponent };
